import { lmsClient } from "api";

const GLAccountService = {};

// GLAccountController uses the framework's [Controller] route token
// (api/lms/GLAccount), not a hand-picked string like BankAccount's
// api/lms/lm_bank_account — do not "fix" this to lm_gl_account, that was
// only ever true of the old finstrust_lms source, not this backend.
const buildGLAccountParams = (data = {}) => {
  const params = new URLSearchParams();
  params.append("glaccountid", data.glaccountid || "");
  params.append("description", data.description || "");
  params.append("pageIndex", data.pageIndex ?? 0);
  params.append("pageSize", data.pageSize ?? 1000);
  return params.toString();
};

// Standard GL account search — reused for the maintenance list, the
// approval list, and getById lookups, filtered client-side by flagData.
// The backend has no dedicated searchapproval/ref/{code} endpoints for GL
// Account the way BankAccount does.
GLAccountService.getGLAccounts = function (data = {}) {
  return lmsClient({
    url: `/lms/GLAccount/search?${buildGLAccountParams(data)}`,
    method: "get",
  });
};

GLAccountService.addGLAccount = function (data) {
  return lmsClient({
    url: `/lms/GLAccount/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

GLAccountService.updateGLAccount = function (data) {
  const { id, ...requestBody } = data;

  return lmsClient({
    url: `/lms/GLAccount/edit`,
    method: "put",
    headers: {
      "x-requestId": id,
    },
    data: requestBody,
  });
};

GLAccountService.approveGLAccount = function (data) {
  return lmsClient({
    url: "/lms/GLAccount/approve",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

GLAccountService.rejectGLAccount = function (data) {
  return lmsClient({
    url: "/lms/GLAccount/reject",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

GLAccountService.returnGLAccount = function (data) {
  return lmsClient({
    url: "/lms/GLAccount/return",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

GLAccountService.requestGLAccount = function (data) {
  return lmsClient({
    url: "/lms/GLAccount/request",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

GLAccountService.deleteGLAccount = function (data) {
  return lmsClient({
    url: "/lms/GLAccount/delete",
    method: "delete",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

export default GLAccountService;
